import { ChevronLeft, ChevronRight } from 'lucide-react'

const PAGE_SIZE = 10

interface PaginationProps {
  page: number
  totalItems: number
  onPageChange: (page: number) => void
  pageSize?: number
}

export default function Pagination({ page, totalItems, onPageChange, pageSize = PAGE_SIZE }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize))
  if (totalItems <= pageSize) return null

  const from = (page - 1) * pageSize + 1
  const to = Math.min(page * pageSize, totalItems)

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1.5rem', fontSize: '0.85rem', color: 'var(--color-gray-500)' }}>
      <span>Showing {from}-{to} of {totalItems}</span>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '2rem', height: '2rem', border: '1px solid var(--color-gray-300)',
            borderRadius: '6px', background: 'white', color: 'var(--color-gray-700)',
            cursor: page <= 1 ? 'not-allowed' : 'pointer',
            opacity: page <= 1 ? 0.4 : 1,
          }}
        >
          <ChevronLeft size={16} />
        </button>
        <span style={{ minWidth: '5rem', textAlign: 'center' }}>Page {page} of {totalPages}</span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '2rem', height: '2rem', border: '1px solid var(--color-gray-300)',
            borderRadius: '6px', background: 'white', color: 'var(--color-gray-700)',
            cursor: page >= totalPages ? 'not-allowed' : 'pointer',
            opacity: page >= totalPages ? 0.4 : 1,
          }}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  )
}

/** Slice an array for client-side pagination */
export function paginate<T>(items: T[], page: number, pageSize: number = PAGE_SIZE): T[] {
  const start = (page - 1) * pageSize
  return items.slice(start, start + pageSize)
}

export { PAGE_SIZE }
